<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <div
                    class="alert alert-danger"
                >O tamanho das imagens pode impactar diretamente na performance e tempo de carregamento do aplicativo.</div>
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fas fa-menu"></i> País
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div
                                    class="col-md-4"
                                    :class="{ 'has-danger': $v.model.nome.$error }"
                                >
                                    <label>Nome*</label>
                                    <input
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="model.nome"
                                    />
                                </div>
                                <div
                                    class="col-md-2"
                                    :class="{ 'has-danger': $v.model.codigo.$error }"
                                >
                                    <label>Código*</label>
                                    <input
                                        type="text"
                                        maxlength="2"
                                        class="form-control"
                                        v-model="model.codigo"
                                    />
                                </div>

                                <div
                                    class="col-md-2"
                                    :class="{ 'has-danger': $v.model.ddi.$error }"
                                >
                                    <label>DDI*</label>
                                    <input
                                        type="text"
                                        maxlength="10"
                                        class="form-control"
                                        v-model="model.ddi"
                                    />
                                </div>

                                <div class="col-md-3 align-self-center">
                                    <label>Ativo</label>
                                    <br />
                                    <input-toggle v-model="model.ativo" :value="model.ativo"></input-toggle>
                                </div>
                            </div>
                            <div class="form-group row">
                              <div
                                  class="col-md-4"
                                  :class="{ 'dropdown-has-error': $v.model.idioma.$error }"
                                  >
                                <label>Idioma*</label>
                                <Select2
                                    placeholder="Selecione"
                                    v-model="model.idioma"
                                    :options="tiposIdioma"
                                    opt-id="idioma"
                                >
                                    <option value selected>Selecione</option>
                                </Select2>
                              </div>

                              <div
                                  class="col-md-4"
                                  :class="{ 'dropdown-has-error': $v.model.id_configuracao.$error }"
                              >
                                  <label>Aplicativo*</label>
                                  <select-api
                                      v-model="model.id_configuracao"
                                      :endpoint="'/configuracao/pesquisa'"
                                      :opt-text="'googlePackageName'"
                                      :select-option="true"
                                  ></select-api>
                              </div>
                            </div>
                            <div class="alert alert-warning">
                                <strong>Atenção!</strong>
                                O tamanho máximo e indicado para a
                                <strong>Imagem</strong> é de
                                <strong>300kb</strong>.
                            </div>
                            <div class="form-group row">
                                <div class="col-md-12">
                                    <file-image
                                        v-model="imagem"
                                        :label="'Imagem'"
                                        :arquivo="model.arquivo"
                                    ></file-image>
                                </div>
                            </div>
                        </div>

                        <div class="card-footer text-right">
                            <router-link
                                :to="{ name: 'list-country' }"
                                class="btn btn-link"
                            >Cancelar</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isNotUndefinedOrNullOrEmptyOrZero,
    isUndefinedOrNullOrEmpty
} from "@/services/string";
import Select from "../../components/Input/Select";
import SelectApi from "../../components/Input/SelectApi";
import FileImage from "../../components/Input/FileImage";
import { isPhone, isCpf, validateCPF } from "@/services/util";
import Collections from "../../helpers/collections";
import Select2 from '../../components/Input/Select2';
export default {
    components: {
        FileImage, Select2, SelectApi
    },
    data() {
        return {
            model: {
                id: null,
                nome: "",
                ddi: "",
                ativo: 0,
                codigo: "",
                arquivo: null,
                imagem: null,
                idioma: '',
                id_configuracao: ''
            },
            tiposIdioma: Collections.idiomas,
            imagem: null
        };
    },
    validations() {
        let vm = this;

        return {
            model: {
                nome: {
                    required,
                    minLength: minLength(2)
                },
                codigo: {
                    required,
                    minLength: minLength(2),
                    maxLength: maxLength(2)
                },
                ddi: {
                    required,
                    minLength: minLength(2)
                },
                idioma: {
                  required,
                  isNotUndefinedOrNullOrEmptyOrZero
                },
                id_configuracao: required
            }
        };
    },
    methods: {
        async save() {
            let vm = this;
            if (this.$v.model.$invalid) {
                this.$v.model.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);

            try {
                const formData = new FormData();
                formData.append("data", JSON.stringify(vm.model));
                formData.append("imagem", vm.imagem);

                let ret = null;

                if (vm.model.id) {
                    ret = await facade.updateCountry(formData, vm.model.id);
                    this.$router.push({ name: "list-country" });
                } else {
                    ret = await facade.createCountry(formData);
                    vm.model.id = ret.data.data.id;
                    this.$router.push({
                        name: "list-country",
                        params: { id: vm.model.id }
                    });
                }

                this.$loading.show(false);
            } catch (e) {
                e.forEach(item => {
                    this.$notify.error(item.field, item.message);
                });
                this.$loading.show(false);
            }
        },
        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(model) {
            let vm = this;

            if (model !== undefined && model !== null) {
                vm.model = model;
            }
        }
    },
    async beforeRouteEnter(to, from, next) {
        let country = null;

        if (to.params.id) {
            country = (await facade.getCountry(to.params.id)).data.data;
        }

        next(vm => vm.setData(country));
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?652aa2ec